import React from 'react'
import { useSelector } from 'react-redux'

import { getCurPatientId, getCurPatientData } from '@web/stores/Account/Select'

import {
  useGetUpcomingAppointments,
  useCheckinTrigger
} from '@web/hooks/api/appointments'

const DataLoader = () => {
  const patientId = useSelector(getCurPatientId)
  const patientDetails = useSelector(getCurPatientData)
  const token = useSelector(state => state.auth.user.idToken)

  const upcoming = useGetUpcomingAppointments({
    patientId,
    token,
    dependentAccount: patientDetails
  })

  const upcomingAppointmentsList =
    upcoming.data?.appointmentLookup?.appointments ?? []

  useCheckinTrigger({
    patientId,
    upcomingAppointments: upcomingAppointmentsList
  })

  return null
}

const AppointmentsDataLoader = prop => {
  return <DataLoader {...prop} />
}

export default AppointmentsDataLoader
